import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { User } from '../models/user.model';
import { SignatureRequest } from '../models/signature-request.model';
import { JsonResponseSingle } from '../models/json-response.interface';
import { SignatoryBasicInfo } from '../models/signatory-basic-info.model';
import { SignatureRequestBasicInfo } from '../models/signature-request-basic-info.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private host:string = environment.laravel_url + "/api/v1";

  constructor(private http:HttpClient) { }

  public getHost() {
    return this.host;
  }

  private setParams(filters:any, params:HttpParams = new HttpParams()) {
    if(filters==null) filters = {};
    Object.entries(filters).forEach((val:[string,any]) => {
      if(val[1]!=undefined && val[1]!=null) {
        if(val[1] instanceof Date /*|| isMoment(val[1])*/) val[1] = val[1].toISOString();
        else if(typeof val[1] === "boolean") val[1] = val[1] ? 1 : 0;
        params = params.set(val[0], val[1]);
      }
    });

    return params;
  }

  /**
   * -------------------------------------------------- AUTHENTICATION --------------------------------------------------
   */
  requestOtp(login:string, signature_request_uuid:string, recaptcha_token:string) {
    return this.http.post<any>(`${this.host}/auth/request-otp`, { email: login, signature_request_uuid: signature_request_uuid, token: recaptcha_token });
  }

  loginOtp(otp:string) {
    return this.http.post<any>(`${this.host}/auth/login-otp`, { otp: otp });
  }

  refreshToken() {
    return this.http.post<any>(`${this.host}/auth/refresh`, {});
  }

  /**
   * -------------------------------------------------- ME --------------------------------------------------
   */
  me() {
    return this.http.get<User>(`${this.host}/me`);
  }

  /**
   * SIGNATURE REQUESTS
   */
  getSignatureRequest(uuid:string, queryParams:any = {}) {
    const query = this.setParams(queryParams);
    return this.http.get<JsonResponseSingle<SignatureRequest>>(`${this.host}/signatures/${uuid}`, { params: query });
  }

  acceptSignatory(signature_request_uuid:string, signatory_uuid:string) {
    return this.http.post<JsonResponseSingle<{accepted:boolean}>>(`${this.host}/signatures/${signature_request_uuid}/signatories/${signatory_uuid}/accept`, {});
  }

  signDocumentRequest(uuid:string, signature:Blob, signAlsoSign:boolean = false, dni:string|null = null) {
    const formData: FormData = new FormData();
    formData.append('signature', signature);
    if(signAlsoSign) formData.append('also_sign', '1');
    if(dni != null && dni !== '') formData.append('dni', dni);

    return this.http.post<JsonResponseSingle<{signed:boolean}>>(`${this.host}/signatures/${uuid}/sign`, formData);
  }

  getSignatureRequestBasicInfo(uuid:string) {
    return this.http.get<JsonResponseSingle<SignatureRequestBasicInfo>>(`${this.host}/signatures/${uuid}/basic-info`);
  }

  /**
   * SIGNATORIES
   */
  getSignatoryBasicInfo(uuid:string) {
    return this.http.get<JsonResponseSingle<SignatoryBasicInfo>>(`${this.host}/signatories/${uuid}/basic-info`);
  }

  /**
   * DOCUMENT
   */
  downloadDocument(document_uuid:string) {
    return this.http.get(`${this.host}/documents/${document_uuid}/download`, { responseType: 'blob' });
  }

}
